import { IAttendanceDetailsServiceResponse } from "../types";
import { IProfileLeaveAttendancePopup } from "../../../Types/UserProfileDetails";
import { attendanceMinutes } from "../../../utils/attendanceDuration";

const duration = (minutes: number) => `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, "0")}`;

export const toAttendanceSummary = (
  response: IAttendanceDetailsServiceResponse,
  range: { startDate: string; endDate: string },
): IProfileLeaveAttendancePopup | undefined => {
  if (!response.summary) return undefined;
  const total = (key: "expected_hours" | "logged_hours" | "deficit_hours") =>
    response.data.reduce((sum, day) => sum + (attendanceMinutes(day[key] ?? 0) ?? 0), 0);
  const deficit = total("deficit_hours");
  return {
    cycle_start: range.startDate,
    cycle_end: range.endDate,
    attendance_summary: response.summary,
    working_hours: {
      cycle_start: range.startDate,
      cycle_end: range.endDate,
      expected_hours: duration(total("expected_hours")),
      logged_hours: duration(total("logged_hours")),
      deficit_hours: duration(deficit),
      has_deficiency: deficit > 0,
      daily_breakdown: response.data.map((day) => ({
        ...day,
        expected_hours: day.expected_hours ?? 0,
        logged_hours: day.logged_hours ?? 0,
        deficit_hours: day.deficit_hours ?? undefined,
        status: day.remark_all,
      })),
    },
  };
};
